import '../reset.css';
import '../style.css';
import {userBrowserId} from '../scripts/common.js';
import './my_katex.js';
import {initIframeResize} from './_inIFrame.js';

initIframeResize();
